export enum EPipedreamConnectErrorType {
  USER_CANCELLED = 'USER_CANCELLED',
  CONNECTION_FAILED = 'CONNECTION_FAILED'
}
